import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Snowflake = createReactComponent("Snowflake", ["svg", defaultAttributes, [["line", {
  x1: "2",
  y1: "12",
  x2: "22",
  y2: "12",
  key: "1vcgga"
}], ["line", {
  x1: "12",
  y1: "2",
  x2: "12",
  y2: "22",
  key: "1hqhh2"
}], ["path", {
  d: "M20 16l-4-4 4-4",
  key: "l0yr60"
}], ["path", {
  d: "M4 8l4 4-4 4",
  key: "y1ko01"
}], ["path", {
  d: "M16 4l-4 4-4-4",
  key: "e29uri"
}], ["path", {
  d: "M8 20l4-4 4 4",
  key: "3figuv"
}]]]);
export default Snowflake;